var map = {
	"./cs/groups.json": 5945,
	"./de/groups.json": 2010,
	"./en/groups.json": 678,
	"./es/groups.json": 8223,
	"./fr/groups.json": 615,
	"./it/groups.json": 8512,
	"./pl/groups.json": 5355,
	"./ru/groups.json": 4272,
	"./tr/groups.json": 6561,
	"./uk/groups.json": 3847,
	"./zh-CN/groups.json": 3427,
	"./zh-TW/groups.json": 911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8662;